export default __webpack_public_path__ + "static/media/torus.042ece44.svg";